import { render, staticRenderFns } from "./Timon.vue?vue&type=template&id=0cf221a8&scoped=true&"
import script from "./Timon.vue?vue&type=script&lang=js&"
export * from "./Timon.vue?vue&type=script&lang=js&"
import style0 from "./Timon.vue?vue&type=style&index=0&id=0cf221a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf221a8",
  null
  
)

export default component.exports